var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.311,
    height: 16.515,
    viewBox: "0 0 18.311 16.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_333",
    "data-name": "Rectangle 333",
    width: 18.311,
    height: 16.515,
    fill: "#1ebcc2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16663",
    "data-name": "Group 16663",
    transform: "translate(4752 839.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16039",
    "data-name": "Group 16039",
    transform: "translate(-4752 -839.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15118",
    "data-name": "Group 15118",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41133",
    "data-name": "Path 41133",
    d: "M7.929,9.433c-.486-.764-.951-1.5-1.421-2.227a.9.9,0,0,0-.221-.252.518.518,0,0,0-.744.173c-.214.343-.421.691-.624,1.041A.224.224,0,0,1,4.7,8.3q-1.822-.006-3.644,0a.242.242,0,0,1-.24-.135,5.364,5.364,0,0,1,8.15-6.794c.051.041.1.083.152.124.008.007.022.007-.006,0,.45-.292.86-.6,1.308-.842a5.291,5.291,0,0,1,7.054,1.924,5.067,5.067,0,0,1-.019,5.617.245.245,0,0,1-.178.1c-1.417.006-2.834,0-4.251.007a.2.2,0,0,1-.2-.135q-.868-1.619-1.742-3.236a.522.522,0,0,0-.72-.293.819.819,0,0,0-.309.347C9.374,6.39,8.708,7.8,8.038,9.217c-.03.063-.063.124-.109.216",
    transform: "translate(0 0)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41134",
    "data-name": "Path 41134",
    d: "M24.514,91.39c1.108,0,2.173-.008,3.239,0a.688.688,0,0,0,.693-.4c.094-.184.211-.356.327-.548.045.066.078.113.109.162.46.722.923,1.444,1.38,2.169a.551.551,0,0,0,1.026-.064q.985-2.089,1.977-4.176l.1-.205c.041.07.074.121.1.174.449.832.9,1.663,1.342,2.5a.651.651,0,0,0,.643.384c1.209-.009,2.417,0,3.626,0H39.3c-.063.069-.1.113-.141.153l-6.8,6.767a.557.557,0,0,1-.9,0l-6.813-6.779c-.037-.037-.07-.076-.133-.144",
    transform: "translate(-22.762 -82.024)",
    fill: "#1ebcc2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsIcon);
export default __webpack_public_path__ + "static/media/appointments_icon.69fd859374683e5d8974ab24243f3975.svg";
export { ForwardRef as ReactComponent };